import React from 'react';
import { node, bool, string } from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router';
import './index.css';

const Item = ({ children, active, link, className, ...rest }) => {
  const Wrapper = link ? Link : 'div';
  const props = {
    className: classnames(
      'TabItem__container',
      { 'TabItem__container--active': active },
      className,
    ),
    to: link,
    ...rest,
  };
  return <Wrapper {...props}>{children}</Wrapper>;
};

Item.propTypes = {
  children: node,
  active: bool,
  link: string,
  className: string,
};

Item.defaultProps = {
  children: null,
  active: false,
  link: null,
  className: null,
};

export default Item;



// WEBPACK FOOTER //
// ../ui-components/components/Tab/Item/index.jsx